// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const MagnifyOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_473_23857)"},"children":[{"tag":"path","attrs":{"d":"M17 12.86v6.04H4.92V6.82h4.33c.04-.6.19-1.19.41-1.72H4.92c-.95 0-1.73.77-1.73 1.72V18.9c0 .95.78 1.73 1.73 1.73H17c.94 0 1.72-.78 1.72-1.73V14.6L17 12.86zm1.12-3.54a3.88 3.88 0 10-1.23 1.22l2.7 2.69L20.8 12l-2.7-2.68zm-3.28.1a2.16 2.16 0 110-4.32 2.16 2.16 0 010 4.31z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_473_23857"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"magnify","theme":"outlined"};

const MagnifyOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={MagnifyOutlinedSvg} />;
  MagnifyOutlined.displayName = 'MagnifyOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(MagnifyOutlined);
